module.exports = __webpack_public_path__ + "static/cover-old-content-55eea398fcbf9345b9ee735965e1c31e.png";